var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExpertOrg)?_c('ExpertWorkPlace'):_c('AdminWorkPlace')
}
var staticRenderFns = []

export { render, staticRenderFns }